export default __webpack_public_path__ + "static/media/JSB-Resume-2022.37b20375.pdf";